import React from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import { directionToDegrees } from '../utils/utils';

const WindBarbMarker = ({ position, speed, direction }) => {
  const degrees = directionToDegrees(direction || 'N');
  const minSize = 20;
  const maxSize = 50;
  const size = Math.min(maxSize, Math.max(minSize, speed * 2));

  let barbColor;
  if (speed < 15) barbColor = '#2ecc71';
  else if (speed < 20) barbColor = '#f1c40f';
  else if (speed < 25) barbColor = '#e67e22';
  else barbColor = '#e74c3c';

  const windIcon = L.divIcon({
    className: 'wind-barb',
    html: `
      <div style="transform: rotate(${degrees + 180}deg); width: ${size}px; height: ${size}px; display: flex; align-items: center; justify-content: center;">
        <svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${barbColor}" stroke-width="2">
          <path d="M12 2L12 22M12 2L6 8M12 2L18 8" />
        </svg>
      </div>
    `,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });

  return (
    <Marker position={position} icon={windIcon} />
  );
};

export default WindBarbMarker;
